import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=7e0e1366&scoped=true&"
import script from "./FooterNew.vue?vue&type=script&lang=js&"
export * from "./FooterNew.vue?vue&type=script&lang=js&"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=7e0e1366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e1366",
  null
  
)

export default component.exports